import axios from 'axios';
import namespace from './namespace';
import AppService from './../../../service/app.js';
import SupportActivityService from './../../../service/supportActivity.js';
import { NAMESPACE as APP_NAMESPACE } from './../app';

let appService = new AppService();
let service = new SupportActivityService(axios);

export default {
    async [namespace.actions.SEND_EVENT] ({ commit, dispatch }, supportEvent) {
        try {
            await service.sendEvent(supportEvent);
        } catch (err) {
            dispatch(APP_NAMESPACE.actions.HANDLE_ERROR, err, {root: true});
        }
    },
    [namespace.actions.SET_UP_SERVICE] ({}, payload) {
        if (payload.prefix !== undefined) {
            service.backendUrl = payload.prefix;
        }
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/support/actions.js